import '../../styles/scss/style.scss'
// import JS modules to compile
import "@babel/polyfill";
import './init-foundation'
import './wp-foundation'
import './modules/fancybox'
//import './modules/store-locator'
//import './modules/defer'
import './modules/navMenu'
//import './modules/scrollMagicAnimations'
import './modules/sliders'
import './modules/swiper'
import './modules/hovers'
//import './modules/lazyLoad'
// import './modules/popmotionAnimations'


// modal
if (!document.cookie.split(';').filter((item) => item.trim().startsWith('imagery_modal=isModal')).length) {
    setTimeout(() => {
        $('#modal').fadeIn(1000)

        $('#modal-close').on('click', (e) => {
            e.preventDefault()
            $('#modal').fadeOut(1000)
        })
    }, 1000)
    setCookie('imagery_modal', 'isModal', 1)
} 
// Clear Cookie
// setCookie('imagery_modal', 'isNotModal', 0)

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

